import { type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface DialogHeaderProps extends HTMLAttributes<HTMLDivElement> {}

export const DialogHeader = ({ className, ...props }: DialogHeaderProps) => (
  <div className={twMerge('text-2xl font-bold mb-4', className)} {...props} />
)

DialogHeader.displayName = 'DialogHeader'
